export const iconFontAwesomeMarketingAnchorCircleXmark = (
	<i className="fa-solid fa-anchor-circle-xmark"></i>
);
